import Subscriptions from "pages/subscriptions";
import SubscriptionDetails from "pages/subscriptions/details";
import OrderDetails from "pages/order/details";
import Orders from "pages/order";

const routes = [
  // Customers
  {
    path: `/subscriptions`,
    exact: true,
    auth: true,
    component: Subscriptions,
  },
  {
    path: `/subscriptions/:orderId`,
    exact: true,
    auth: true,
    component: SubscriptionDetails,
  },
  { path: `/order/:slotId`, exact: true, auth: true, component: OrderDetails },
  { path: `/orders`, exact: true, auth: true, component: Orders },
];

export default routes;
